import { render, staticRenderFns } from "./teacher-list-add.vue?vue&type=template&id=15058906&scoped=true&"
import script from "./teacher-list-add.vue?vue&type=script&lang=js&"
export * from "./teacher-list-add.vue?vue&type=script&lang=js&"
import style0 from "./teacher-list-add.vue?vue&type=style&index=0&id=15058906&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15058906",
  null
  
)

export default component.exports